/* eslint-disable */
import { Paper, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import React from 'react';
import { compose } from 'redux';
import FileUpload from '../../Components/FileUpload/FileUpload.component';
import Page from '../../Components/Page/Page.component';
import withServices from '../../Contexts/Services/WithServices.context';
import envGet from '../../Support/Env/Get/EnvGet.support';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import OrdersPageSidebar from '../Orders/Orders.page.sidebar';
import './Admin.page.i18n';
import AdminPagePropTypes from './Admin.page.props';
import dashboardPageStyles from './Admin.page.styles';

const baseUrl = envGet({ key: `REACT_APP_BORAL_BASE_URL` });

/**
 * AdminPageComponent
 * @export
 * @param {any} response The response
 * @class AdminPageComponent
 * @extends {React.Component<AdminPageComponentComposedProps, AdminPageComponentState>}
 */
export class AdminPageComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<AdminPageComponentProps>}
   * @memberof AdminPageComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`AdminPage`}
   * @memberof AdminPageComponent
   */
  static displayName = `AdminPage`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof AdminPageComponent
   */
  static propTypes = AdminPagePropTypes;

  /**
   * Data specific to the `<AdminPage />` instance
   * @type {AdminPageComponentState}
   * @memberof AdminPageComponent
   */
  state = {
    response: null,
  };

  renderResponse = (response) => {
    if (!response) {
      return <Typography>No Response</Typography>;
    }
    const { classes } = this.props;
    const results = response.map(({ index, email, status }) => {
      const message = `#${index - 1}: ${email} - ${status}`;
      if (status !== `ERROR`) {
        return null;
      }
      return (
        <Typography component="p" key={`${email}-${index}`}>
          {message}
        </Typography>
      );
    });
    const allOk = results.filter(Boolean).length === 0;
    return (
      <Paper className={classes.root}>
        <Typography gutterBottom variant="h5">
          Results
        </Typography>
        {allOk ? <Typography>All OK</Typography> : results}
      </Paper>
    );
  };

  /**
   * Render the component
   * @returns {React.Component} The rendered `<AdminPage />`
   * @memberof AdminPageComponent
   */
  render() {
    const { classes, services } = this.props;
    const { response } = this.state;
    return (
      <Page className={cn(classes.root)} heading="AdminPage.PageHeading" sidebarContent={<OrdersPageSidebar />} title="AdminPage.PageTitle">
        <Typography gutterBottom variant="h6">
          CSV Users Upload
        </Typography>
        <FileUpload
          inputProps={{
            accept: `.csv`,
          }}
          onChange={() => this.setState({ response: null })}
          onSuccess={(res) => this.setState({ response: res })}
          renderErrors={(errors) => errors}
          uploadProps={{
            headers: services.authService.createHeaders(),
            method: services.httpService.post,
            url: `${baseUrl}/order-service/users/upload`,
          }}
        />
        {response && this.renderResponse(response)}
      </Page>
    );
  }
}

/** @type {React.ComponentClass<AdminPageComponentProps>} */
const AdminPage = compose(
  withServices,
  withStyles(themeCreateInjectableStyles(dashboardPageStyles), { withTheme: true }),
)(AdminPageComponent);

export default AdminPage;
